export default function Slider(theme) {
  return {
    MuiSlider: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.main,
          height: 4,
          '& .MuiSlider-thumb': {
            width: 16,
            height: 16,
            boxShadow: theme.shadows[2],
            '&:hover': {
              boxShadow: theme.shadows[4],
            },
            '&.Mui-focusVisible': {
              boxShadow: theme.shadows[4],
            },
          },
          '& .MuiSlider-track': {
            height: 4,
            borderRadius: 2,
          },
          '& .MuiSlider-rail': {
            height: 4,
            borderRadius: 2,
            backgroundColor: theme.palette.grey[300],
          },
        },
      },
    },
  };
}

